import script from "./apply-choose-guide.vue?vue&type=script&lang=ts&setup=true"
export * from "./apply-choose-guide.vue?vue&type=script&lang=ts&setup=true"

import "./apply-choose-guide.vue?vue&type=style&index=0&id=2d50b1e0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d50b1e0"]])

export default __exports__